import FirstInputForm from "../../components/PageComponents/FirstInputForm/FirstInputForm.js";

const FirstInputPage = () => {
  return (
    <div className="FirstInputPage">
      <FirstInputForm />
    </div>
  );
};

export default FirstInputPage;
